<template>
  <div class="full-width full-height overflow-hidden">
    <div
      class="full-height overflow-hidden d-flex flex-column"
      :class="{ table_auth: isList, grid_auth: isGrid }"
    >
      <div v-if="useTop" class="flex-grow-0 py-2">
        <PaginationOrderShow
          :total="p_pagination.total"
          :length="c_items.length"
          :headers="headers"
          @update:orderBys="onUpdateOrderBys"
        >
          <template #prepend>
            <slot name="top-prepend"> </slot>
          </template>
          <template #left>
            <slot name="top-left"> </slot>
          </template>
          <template #right>
            <slot name="top-right"> </slot>
          </template>
          <template #append-right>
            <slot name="top-append-right"> </slot>
          </template>
        </PaginationOrderShow>
      </div>
      <div class="flex-grow-0" v-if="$slots['below-top']">
        <slot name="below-top"></slot>
      </div>
      <div class="flex-grow-1 overflow-auto">
        <div class="full-height d-flex ">
          <div
            class="flex-grow-1"
            :style="{ width: slotTableRight ? '50%' : '100%' }"
          >
            <div class="full-height d-flex flex-column">
              <div class="flex-grow-1 overflow-hidden full-height">
                <component
                  v-bind="$attrs"
                  v-on="$listeners"
                  :is="componentsLoad"
                  :headers="showHeaders"
                  :isScrollLoad="!showPagination"
                  :items="c_items"
                  :loading="c_loading"
                  :orderBys="p_orderBys"
                  :pagination="c_pagination"
                  @loadMoreData="onLoadMore"
                  @input="$emit('input', $event)"
                  @update:orderBys="onUpdateOrderBys"
                  @click:create="$emit('click:create', $event)"
                >
                  <template #no-data>
                    <slot name="no-data" />
                  </template>
                  <template
                    v-for="slot in slotItemHeader"
                    v-slot:[slot]="props"
                  >
                    <slot v-bind="props" :name="slot" />
                  </template>
                  <template v-for="slot in slotItemRow" v-slot:[slot]="props">
                    <slot v-bind="props" :name="slot" />
                  </template>
                </component>
              </div>
              <div v-if="showPagination" class="flex-grow-0 py-2">
                <base-pagination
                  :disabled="c_loading"
                  :page.sync="p_pagination.page"
                  :perpage.sync="p_pagination.itemsPerPage"
                  :total="p_pagination.total"
                  @update:page="onUpdatePage"
                  @update:perpage="onUpdatePerPage"
                ></base-pagination>
              </div>
            </div>
          </div>
          <div
            class="flex-grow-1 pl-2"
            v-if="!!slotTableRight"
            :style="{ width: '50%' }"
          >
            <slot name="table-right"> </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationOrderShow from '../pagination-order-show.vue'
import ItemMixin from './mixin.item'
import ParamsMixin from './mixin.params'
import asyncComponent from '../../async'
export default {
  mixins: [ItemMixin, ParamsMixin],
  components: {
    PaginationOrderShow,
    BaseGrid: () =>
      asyncComponent(
        import(
          /* webpackChunkName: "base-table-async-" */ '../grid/base-grid.vue'
        ),
        { type: 'table-thead, table-tbody' }
      ),
    BaseInfiniteScroll: () =>
      asyncComponent(
        import(
          /* webpackChunkName: "base-table-async-" */ '../infinite-scroll/base-infinite-scroll.vue'
        ),
        { type: 'table-thead, table-tbody' }
      ),
  },
  data: () => ({}),
  computed: {
    slotItemRow() {
      return Object.keys(this.$scopedSlots).filter((x) => x.includes('item'))
    },
    slotItemHeader() {
      return Object.keys(this.$scopedSlots).filter((x) => x.includes('header'))
    },
    slotTableRight() {
      return this.$slots['table-right']
    },
  },
  methods: {},
}
</script>

<style scoped lang="scss">
.table_auth {
  border-left: thin solid rgba(0, 0, 0, 0.12);
  border-right: thin solid rgba(0, 0, 0, 0.12);
  .tool-panel-wrapper {
    width: 250px;
    height: 100%;
    overflow: hidden;
    border-left: thin solid rgba(0, 0, 0, 0.12);
  }
  .side-buttons {
    border-left: thin solid rgba(0, 0, 0, 0.12);
    height: 100%;
    width: 30px;
    padding-top: 24px;
    overflow: hidden;
    position: relative;
    .side-button {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-left: 2px solid transparent;
      transition: border-left 0.3s;
      padding: 12px 0;
      width: 100%;
      margin: 0;
      min-height: 108px;
      .side-button-label {
        writing-mode: tb-rl;
      }
      &.side-button-active {
        border-left-color: var(--v-primary-base);
      }
    }
  }
}
</style>
<style lang="scss">
.table_auth {
  tr th {
    height: 28px;
  }
  td {
    height: 28px;
  }
}
</style>
